import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {
  instructionDescriptionZod,
  instructionIsDraftZod,
  instructionMarkdownZod,
  instructionPathZod,
} from './schemas';

const toolName = 'create-instruction' as const;

const argumentZod = z.object({
  path: instructionPathZod.describe(
    'The instruction file path to create, for example rules/brand.md or brand-guidelines/SKILL.md.'
  ),
  markdown: instructionMarkdownZod.describe(
    'The full markdown content to store at the instruction path.'
  ),
  description: instructionDescriptionZod,
  isDraft: instructionIsDraftZod,
});

export const createInstructionManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Create instruction',
  llmTool: {
    name: toolName,
    description:
      'Creates a new agent instruction markdown file in the current site. If lacking context on the existing instructions, use search-instructions first to avoid overwriting an existing file path.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AGENT_INSTRUCTIONS,
  permission: [{resource: 'SiteAgentInstructions', action: 'manage'}],
  confirmBeforeExecuting: true,
});

export type CreateInstructionArgumentType = z.infer<typeof argumentZod>;
